import React from 'react';

interface CategorySelectionMessageProps {
  selectedCategory: string;
  availableCategoriesCount: number;
  error?: string;
}

// Category Selection Message
const CategorySelectionMessage: React.FC<CategorySelectionMessageProps> = ({
  selectedCategory,
  availableCategoriesCount,
  error,
}) => {
  if (selectedCategory || availableCategoriesCount === 0 || error) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 text-center">
      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          className="w-8 h-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          />
        </svg>
      </div>
      <h3 className="text-lg font-baijamjuree font-bold text-gray-900 mb-2">
        Select a Category to Begin Evaluation
      </h3>
      <p className="text-gray-600 font-baijamjuree">
        Choose a category from the dropdown above to start evaluating final
        submissions.
      </p>
    </div>
  );
};

export default CategorySelectionMessage;
